import { useState, useEffect, useContext, useReducer } from "react";
import { useNavigate } from 'react-router-dom';
import { useTable, usePagination } from 'react-table';
import Select from 'react-select';
import "../../css/ListUsers.css";
import Header from "../Navigation/Header";
import Footer from "../Navigation/Footer";
import WorkLocationReadOnlyRow from "../../components/WorkLocationReadOnlyRow";
import WorkLocationModal from "../../components/WorkLocationModal";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { ddStyles } from "../../utils/CommonStyles.js";

const initialState = {
    queryPageIndex: 0,
    queryPageSize: 25,
    totalCount: 0,
    queryPageFilter: { companyId: 0, departmentKey: 0 },
};

const PAGE_CHANGED = 'PAGE_CHANGED';
const TOTAL_COUNT_CHANGED = 'TOTAL_COUNT_CHANGED';
const PAGE_FILTER_CHANGED = 'PAGE_FILTER_CHANGED';

const reducer = (state, { type, payload, t }) => {
    switch (type) {
        case PAGE_CHANGED:
            return {
                ...state,
                queryPageIndex: payload.pageIndex,
            };
        case TOTAL_COUNT_CHANGED:
            return {
                ...state,
                totalCount: payload.count,
            };
        case PAGE_FILTER_CHANGED:
            return {
                ...state,
                queryPageFilter: payload || 0,
                totalCount: 0,
                queryPageIndex: 0,
            };
        default:
            throw new Error(t("error.unhandledException") + " : ${type}");
    }
};

let prevCount = 0;
function setPrevCount(newCount) {
    prevCount = newCount;
}


function ListWorkLocations() {
    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [add, setAdd] = useState(false);
    const [errorValue, setErrorValue] = useState("");
    const [data, setData] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [count, setCount] = useState(0);
    const [companyId, setCompanyId] = useState(0);
    const [companyLoaded, setCompanyLoaded] = useState(false);
    const [companySelected, setCompanySelected] = useState({ name: "companyId", label: "", value: 0 });
    const [deptOptions, setDeptOptions] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [departmentKey, setDepartmentKey] = useState(0);
    const [departmentLoaded, setDepartmentLoaded] = useState(false);
    const [departmentSelected, setDepartmentSelected] = useState({ name: "departmentKey", label: "", value: 0 });
    const [useFilter, setUseFilter] = useState(false);
    const [keyCount, setKeyCount] = useState(0);
    const { t } = useTranslation();
    const userCtx = useContext(UserContext);

    const [columns, setColumns] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    let userCompanyId = (userCtx.role !== "SiteAdmin") ? userCtx.userCompanyId : 0;

    useEffect(() => {
        fetchCompanies();
        setColumns([
            { accessor: 'locationName', Header: t("page.loc"), maxWidth: "20vw" },
            { accessor: 'operationTypeDesc', Header: t("page.oper.type"), maxWidth: "10vw" },
            { accessor: 'operationArea', Header: t("page.oper.area"), maxWidth: "10vw" },
            { accessor: 'description', Header: t("page.description"), maxWidth: "15vw" },
            { accessor: 'address', Header: t("page.address"), maxWidth: "15vw" },
            { accessor: 'phone', Header: t("page.phone"), maxWidth: "10vw" },
            { accessor: 'status', Header: t("page.status"), maxWidth: "5vw" },
            { accessor: 'action', Header: t("page.action"), maxWidth: "15vw" },
        ]);
    }, []);

    const handleModalClose = () => {
        setShow(false);
        setAdd(true);
    };

    const initialValues = {
        companyId: 0,
        departmentKey: 0,
        locationKey: 0,
        companyName: "",
        locationName: "",
        description: "",
        address1: "",
        address2: "",
        phone: "",
        zipCode: "",
        zipExt: "",
        city: "",
        stateKey: 0,
        stateCode: "",
        countryCode: "US",
        locationTimeZone: "America/Los_Angeles",
        geocode: "",
        latitude: "",
        longitude: "",
        operationTypeKey: 0,
        operationArea: "Farm",
        isUnknown: 0,
        HepAVaccRate: "",
        isChecked: 0,
        waterSources: [],
        waterEquimentClean: [],
        waterFruitWashValue: 0,
        potableWaterValue: 0,
        wasteTreatmentValue: 0,
        humanBiosolidValue: 0,
        housingDensityValue: 0,
        workerNationalityValue: 0

    };
    const [editFormData, setEditFormData] = useState(initialValues);

    function fetchCompanies() {
        setErrorValue("");
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false, userCompanyId: userCompanyId }),
        };
        try {
            FetchUtil.fetchAPI("FetchCompanies", "/Service/CompanyService/FetchCompanies", requestOptions, fetchCompaniesSuccess, fetchCompaniesFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function fetchCompaniesFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.companyListNotRetrieved"));
    }
    function fetchCompaniesSuccess(responseData) {
        let fetchCompaniesResponse;
        if (responseData) {
            fetchCompaniesResponse = responseData.fetchCompaniesResponse;
            if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "0") {
                setCompanyValues(fetchCompaniesResponse.companies);
                setCompanies(fetchCompaniesResponse.companies);
            } else if (fetchCompaniesResponse && fetchCompaniesResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchCompaniesResponse) {
                setErrorValue(t("error.error") + " " + fetchCompaniesResponse.errorMessage);
                setCompanyValues([]);
            } else {
                setErrorValue(t("error.system.fetch"));
                setCompanyValues([]);
            }
        }
    }
    function setCompanyValues(companyObj) {
        let companyValue = {};
        let companyOptionList = [];
        companyOptionList.push({ label: "", value: 0 });
        if (companyObj && companyObj.length > 0) {
            companyObj.map((company, index) => {
                companyValue.label = company.companyName + ', ' + (company.city ? company.city + ', ' : '') + company.stateCode + ', ' + company.countryCode;
                companyValue.value = company.companyId;
                companyOptionList.push(companyValue);
                companyValue = {};
            });
        }
        setCompanyOptions(companyOptionList);
        setCompanyLoaded(true);
    }

    const companyHandler = (selectedOption, action) => {
        let selectedCompanyId = selectedOption ? selectedOption.value : 0;
        let selectedCompanyName = selectedOption ? selectedOption.label : "";

        if (companyId === selectedCompanyId) {
            return
        }

        setCompanyId(selectedCompanyId);
        setCompanySelected({ ...companySelected, label: selectedCompanyName, value: selectedCompanyId });
        setDepartmentKey(0);
        setCount(0);
        setUseFilter(false);
        setAdd(false);
        setData([]);
        setDepartmentSelected({ ...departmentSelected, label: "", value: 0 });
        setDeptOptions([]);
        setDepartments([]);
        if (selectedCompanyId && selectedCompanyId > 0) {
            fetchDepartments(selectedCompanyId);
        }
    }

    function fetchDepartments(selectedCompanyId) {
        setErrorValue("");
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ source: "web", getAll: false, companyId: selectedCompanyId }),
        };
        try {
            FetchUtil.fetchAPI("GetDepartments", "/Service/CompanyService/GetDepartments", requestOptions, fetchDepartmentsSuccess, fetchDepartmentsFail);
        } catch (error) {
            throw new Error(error.message);
        }
    }

    function fetchDepartmentsFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.deptNotRetrieved"));
    }
    function fetchDepartmentsSuccess(responseData) {
        let fetchDepartmentsResponse;
        if (responseData) {
            fetchDepartmentsResponse = responseData.fetchDepartmentsResponse;
            if (fetchDepartmentsResponse && fetchDepartmentsResponse.errorCode === "0") {
                setDepartmentValues(fetchDepartmentsResponse.departments);
                setDepartments(fetchDepartmentsResponse.departments);
            } else if (fetchDepartmentsResponse && fetchDepartmentsResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchDepartmentsResponse) {
                setErrorValue(t("error.error") + " " + fetchDepartmentsResponse.errorMessage);
                setDepartmentValues([]);
            } else {
                setErrorValue(t("error.system.fetch"));
                setDepartmentValues([]);
            }
        }
    }
    function setDepartmentValues(deptObj) {
        let deptValue = {};
        let deptOptionList = [];
        deptOptionList.push({ label: "", value: 0 });
        if (deptObj && deptObj.length > 0) {
            deptObj.map((department, index) => {
                deptValue.label = department.departmentName;
                deptValue.value = department.departmentKey;
                deptOptionList.push(deptValue);
                deptValue = {};
            });
        }
        setDeptOptions(deptOptionList);
        setDepartmentLoaded(true);
        setDepartmentSelected({ ...departmentSelected, label: "", value: 0 });
    }

    const deptHandler = (selectedOption, action) => {
        let selectedDeptKey = selectedOption ? selectedOption.value : 0;
        let selectedDeptName = selectedOption ? selectedOption.label : "";

        if (departmentKey === selectedDeptKey) {
            return
        }

        setDepartmentKey(selectedDeptKey);
        setDepartmentSelected({ ...departmentSelected, label: selectedDeptName, value: selectedDeptKey });

        if (selectedDeptKey && selectedDeptKey > 0) {
            setUseFilter(true);
            setAdd(true);
        } else {
            setCount(0);
            setUseFilter(false);
            setData([]);
            setAdd(false);
        }
    }

    const [{ queryPageIndex, queryPageSize, totalCount, queryPageFilter }, dispatch] =
        useReducer(reducer, initialState);

    const { isError, error, isSuccess, refetch } = useQuery(
        ['location-list', queryPageIndex, queryPageSize, queryPageFilter],
        () => retrieveWorkLocation(queryPageIndex, queryPageSize, queryPageFilter),
        {
            keepPreviousData: false,
            staleTime: 1000,
            enabled: useFilter,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        }
    );


    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        // Get the state from the instance
        state: { pageIndex, pageSize },
    } = useTable(
        {
            columns,
            data: isSuccess ? data : [],
            initialState: {
                pageIndex: queryPageIndex,
                pageSize: queryPageSize,
            },
            manualPagination: true,
            pageCount: isSuccess ? Math.ceil(count / queryPageSize) : null,
        },
        usePagination
    );

    useEffect(() => {
        dispatch({ type: PAGE_CHANGED, payload: { pageIndex: pageIndex, companyId: companyId, departmentKey: departmentKey }, t: t });
    }, [pageIndex]);

    useEffect(() => {
        if (count !== prevCount) {
            dispatch({
                type: TOTAL_COUNT_CHANGED,
                payload: { count: count, companyId: companyId, departmentKey: departmentKey },
                t: t
            });

            setPrevCount(count);
        }
    }, [count]);

    useEffect(() => {
        dispatch({ type: PAGE_FILTER_CHANGED, payload: { count: 0, companyId: companyId, departmentKey: departmentKey }, t: t });
        gotoPage(0);
    }, [useFilter, companyId, departmentKey, gotoPage]);

    function retrieveWorkLocation(page, dispSize, queryFilter) {
        setErrorValue("");
        if (!queryFilter || !queryFilter.companyId || queryFilter.companyId === 0
            || !queryFilter.departmentKey || queryFilter.departmentKey === 0) {
            return;
        }
        setData([]);
        setIsLoading(true);
        const offset = page * dispSize;
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true,
                offset: offset, limit: dispSize, companyId: queryFilter.companyId,
                departmentKey: queryFilter.departmentKey
            }),
        };
        try {
            FetchUtil.fetchAPI("GetWorkLocations", "/Service/CompanyService/GetWorkLocations", requestOptions, retrieveWorkLocationSuccess, retrieveWorkLocationFail);
        } catch (error) {
            setIsLoading(false);
            throw new Error(error.message);
        }
    }

    function retrieveWorkLocationFail(redirect) {
        setIsLoading(false);
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.locNotRetrieved"));
    }

    function retrieveWorkLocationSuccess(responseData) {
        let fetchWorkLocationsResponse;
        if (responseData) {
            fetchWorkLocationsResponse = responseData.fetchWorkLocationsResponse;
            if (fetchWorkLocationsResponse && fetchWorkLocationsResponse.errorCode === "0") {
                setData(fetchWorkLocationsResponse.locations.slice());
                if (fetchWorkLocationsResponse.offset === 0) {
                    setCount(fetchWorkLocationsResponse.totalCount);
                }
            } else if (fetchWorkLocationsResponse && fetchWorkLocationsResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (fetchWorkLocationsResponse) {
                setErrorValue(t("error.error") + " " + fetchWorkLocationsResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
        setIsLoading(false);
    }

    const handleAddClick = (event) => {
        event.preventDefault();
        setErrorValue("");
        setShow(true);
        setAdd(true);
        setEditFormData(initialValues);
    }
    const handleEditClick = (event, location) => {
        event.preventDefault();
        event.stopPropagation();
        setErrorValue("");
        let formData = JSON.parse(JSON.stringify(location));
        //console.log(formData);
        setEditFormData({ ...editFormData, ...formData });
        setShow(true);
        setAdd(false);
    };

    const handleDeleteClick = (event, locationKey, statusCode) => {
        event.preventDefault();
        setErrorValue("");
        setAdd(false);
        deleteLocation(companySelected.value, locationKey, statusCode);
        setAdd(true);
    };

    const deleteLocation = (selectedCompanyInfo, locationKey, statusCode) => {
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", companyId: selectedCompanyInfo, locationKey: locationKey,
                statusCode: statusCode, updatedById: userCtx.loggedInUserId
            }),
        };
        try {
            FetchUtil.fetchAPI("DeleteWorkLocation", "/Service/CompanyService/DeleteWorkLocation", requestOptions, deleteWorkLocationSuccess, deleteWorkLocationFail);
        } catch (error) {
            setErrorValue(error.message);
        }
    }

    function deleteWorkLocationFail(redirect) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.locDeleteFailed"));
    }

    function deleteWorkLocationSuccess(responseData) {
        let deleteWorkLocationResponse;
        if (responseData) {
            deleteWorkLocationResponse = responseData.deleteWorkLocationResponse;
            if (deleteWorkLocationResponse && deleteWorkLocationResponse.errorCode === "0") {
                // only retrieve the modified user
                handleRefresh();
            } else if (deleteWorkLocationResponse) {
                handleRefresh();
                setErrorValue(t("error.error") + " " + deleteWorkLocationResponse.errorMessage);

            } else {
                setErrorValue(t("error.system.update"));
            }
        }
    }

    const handleRefresh = () => {
        refetch();
        setAdd(true);
        setKeyCount(prevCount => prevCount + 1);
    };

    if (isError) {
        setErrorValue(t("error.error") + " " + error.message);
    }

    return (
        <div className="container-fluid">
            <Header />
            <div className={show ? "container-fluid container_list viewh-85 pe-none" : "container-fluid container_list viewh-85"}>
                {(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
                    <>
                        <div className="row">
                            <div className="col">
                                <div
                                    id="inerrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <div id="placeholder_1" className="placeholder-pg"></div>
                            </div>
                        </div>
                        <div className="row" style={{ textAlign: "left" }}>
                            <div className="col">
                                <div className="form-group search-dd">
                                    <label className="form-label">
                                        <span className="form_required">*</span>
                                        {t("page.company")}
                                    </label>
                                    <Select
                                        name="companyId"
                                        options={companyOptions}
                                        onChange={companyHandler}
                                        placeholder={""}
                                        value={companySelected}
                                        isSearchable={companyLoaded}
                                        isClearable={companyLoaded}
                                        className="myselect"
                                        inputId="companyId-input"
                                        styles={ddStyles}
                                    />
                                </div>
                                <div className="form-group search-dd">
                                    <label className="form-label">
                                        <span className="form_required">*</span>
                                        {t("page.dept")}
                                    </label>
                                    <Select
                                        name="departmentKey"
                                        options={deptOptions}
                                        onChange={deptHandler}
                                        placeholder={""}
                                        value={departmentSelected}
                                        isSearchable={departmentLoaded}
                                        isClearable={departmentLoaded}
                                        className="myselect"
                                        inputId="departmentKey-input"
                                        styles={ddStyles}
                                    />
                                </div>
                            </div>
                            {(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
                        </div>
                        <div className="row">
                            <div className="col">
                                <div id="placeholder_2" className="placeholder-pg"></div>
                            </div>
                        </div>
                        {add &&
                            <div className="row">
                                <div className="col">
                                    <button className="btn btn-primary btn-block me-4" data-toggle="modal" data-target="#locationModal"
                                        onClick={(event) => handleAddClick(event)}>{t("page.loc.add")}</button>
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col">
                                {isSuccess ? (
                                    <>
                                        <table key={keyCount} className="list-table" {...getTableProps()}>
                                            <thead>
                                                {headerGroups.map(headerGroup => (
                                                    <tr {...headerGroup.getHeaderGroupProps()}>
                                                        {headerGroup.headers.map(column => (
                                                            <th className="list-th" 															{...column.getHeaderProps({
                                                                style: { maxWidth: column.maxWidth },
                                                            })}>{column.render("Header")}</th>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </thead>
                                            <tbody {...getTableBodyProps()}>
                                                {data.length > 0 && (
                                                    data.map((location, index) => (
                                                        (location) &&
                                                        <WorkLocationReadOnlyRow
                                                            t={t}
                                                            location={location}
                                                            handleEditClick={handleEditClick}
                                                            handleDeleteClick={handleDeleteClick}
                                                            oddIdx={((index % 2) > 0) ? true : false}
                                                        />
                                                    ))
                                                )}
                                            </tbody>

                                        </table>

                                        <div className="pagination">
                                            <button className="nav-button" onClick={() => { gotoPage(0); }} disabled={!canPreviousPage}>
                                                {'<<'}
                                            </button>
                                            <button className="nav-button" onClick={() => { previousPage(); }} disabled={!canPreviousPage}>
                                                {'<'}
                                            </button>
                                            <button className="nav-button" onClick={() => { nextPage(); }} disabled={!canNextPage}>
                                                {'>'}
                                            </button>
                                            <button className="nav-button"
                                                onClick={() => { gotoPage(pageCount - 1); }}
                                                disabled={!canNextPage}
                                            >
                                                {'>>'}
                                            </button>
                                            <span className="nav-page-info">{t("page.page") + ' '}
                                                <strong>
                                                    {pageOptions.length > 0 ? pageIndex + 1 : 0} {t("page.of")} {pageOptions.length}
                                                </strong>
                                            </span>
                                            <span className="nav-page-goto">{t("page.goToPage")}:{' '}
                                                <input
                                                    type="number"
                                                    value={pageIndex + 1}
                                                    onChange={(e) => {
                                                        const page = e.target.value ? Number(e.target.value) - 1 : 0;
                                                        gotoPage(page);
                                                    }}
                                                    className="nav-goto-input"
                                                />
                                            </span>
                                        </div>
                                    </>
                                ) : null}
                            </div>
                        </div>
                        {add &&
                            <div className="row">
                                <div className="col">
                                    <button className="btn btn-primary btn-block me-4" data-toggle="modal" data-target="#locationModal"
                                        onClick={(event) => handleAddClick(event)}>{t("page.loc.add")}</button>
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col">
                                <div
                                    id="berrorMessage"
                                    className={
                                        (errorValue) ? "errorblock" : "errorblock hide"
                                    }
                                >
                                    {errorValue ? errorValue : ""}
                                </div>
                            </div>
                        </div>
                    </>
                    : null}
            </div>
            <div className="footer_container">
                <Footer />
            </div>
            {show && <WorkLocationModal t={t} companyList={companies} companyId={companyId} deptList={departments} departmentKey={departmentKey}
                location={editFormData} setShow={setShow} refetch={handleRefresh} add={add} modalClosed={handleModalClose} />}
        </div>
    );
}

export default ListWorkLocations;